import { throwError as observableThrowError } from 'rxjs';
import { Injectable, OnInit, AfterViewInit } from '@angular/core';

//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { TranslateService } from './translate.service';
import * as moment from 'moment'; // DateTimeOffset-Fix


export const httpOptions =
  new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  });


  // MODIs gegenüber IMKE-Standard IN ALLEN crudbuilder-SERVICES angepasst:
  //
  // getXXX(id: number)
  //   this.apiBaseUrl + 'xxx?id=' + id       statt     this.apiBaseUrl + 'xxx/' + id
  //   , withCredentials: true
  //   //response
  //   {
  //     console.log("xxxService.getKopfdaten() response: ", response)
  //     return response[0];
  //   }
  //
  // getXXXCollection()
  //   , withCredentials: true
  //   return ... pagination: /*<IPagination>JSON.parse(response.headers.get('x-pagination'))*/this.getDummyPagination((<any[]>response.body).length)
  //
  // updateXXX(...)
  //   this.apiBaseUrl + 'xxx'      statt     this.apiBaseUrl + 'xxx/' + id
  //
  // initialize...()
  //   createdBy: '',
  //   created: /*''*/'0001-01-01T00:00:00.000Z', // fix
  //   modifiedBy: '',
  //   modified: /*''*/'0001-01-01T00:00:00.000Z', // fix


@Injectable()
export class CRUDBasicService{

  apiBaseUrl: string;

  constructor(
    /*private*/protected httpClient: HttpClient,
    //protected translate: TranslateService,
    /*private*/protected config: AppconfigService
    ) 
  {
  
    //console.log("CRUDBASIC SERVICE THIS: ", this)

    this.apiBaseUrl = this.config.get('apiBaseUrl');
  }


  propertyTypeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property;
    else {
      console.log("CRUDBasicService.propertyTypeOf() return null, since not found. propertyName:", propertyName)
      return null;    
    }
  }
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    //{name: 'myField', type: 'decimal', format: '$'},
  ];

  getDummyPagination(totalCount: number) { // simuliert die pagination im IMKE-Stil, die normalerweise der Controller zurückgibt
    let dummyPagination = {
      previousPageLink: null,
      nextPageLink: null,
      totalCount: totalCount,
      pageSize: totalCount,
      currentPage: 1,
      totalPages: 1
    };
    return dummyPagination;
  }

  // DateTimeOffset-Fix 
  dateToString(datum: Date, eraseTime: boolean) {
    //console.log("CRUDBasicService.dateToString()");
    if (datum != null) {
      let _string = moment(datum).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      if(eraseTime==true) _string = _string.substring(0, 'YYYY-MM-DD'.length)+/*"T00:00:00+00:00"*/"T00:00:00.000Z";
      else                _string = _string.substring(0, 'YYYY-MM-DDTHH:mm:ss.SSS'.length)+"Z";
      console.log("CRUDBasicService.dateToString() return:", _string);
      return _string;
    }
    return null;
  }
  // Falls NUR EINZELNE mit "eraseTime" gefixt werden sollen:
  // z.B. 
  //this.objDateToString(itemToSave, this.propertyTypes.filter(f => ['pruefdatum', 'weiteresFeld'].includes(f.name)==false), false); 
  //this.objDateToString(itemToSave, this.propertyTypes.filter(f => ['pruefdatum', 'weiteresFeld'].includes(f.name)), true);
  objDateToString(item: any, propertyTypes: any[], eraseTime: boolean) {
    //console.log("CRUDBasicService.objDateToString()");
    propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (item[propertyType.name] != null) {
        //item[propertyType.name] = moment(item[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
        //if(eraseTime==true) item[propertyType.name] = item[propertyType.name].substring(0, 'YYYY-MM-DD'.length)+/*"T00:00:00+00:00"*/"T00:00:00.000Z";
        //else                item[propertyType.name] = item[propertyType.name].substring(0, 'YYYY-MM-DDTHH:mm:ss.SSS'.length)+"Z";
        item[propertyType.name] = this.dateToString(item[propertyType.name], eraseTime);
        console.log("CRUDBasicService.objDateToString() replaced "+propertyType.name+" to value:", item[propertyType.name]);
      }
    });
  }

  arrayOfObjDateToString(arrayOfItems: any[], propertyTypes: any[], eraseTime: boolean) {
    console.log("CRUDBasicService.arrayOfObjDateToString() arrayOfItems/propertyTypes:", arrayOfItems, propertyTypes);
    if(arrayOfItems != null) {
      arrayOfItems.forEach(item => {
        this.objDateToString(item, propertyTypes, eraseTime);
      });
    }
  }

  /*private*/protected handleError(error) {
    console.log("CRUDBasicService.handleError error: ", error);
    //console.trace();

    if(error.status === 422 && (error.error.DbUpdateException || error.error.Error)) { // Modi: ohne "error.error.DbUpdateException" webpack-error! / Ohne "error.error.Error" wird zB bei Tags der Fehler "Es existiert bereits ein Tag mit dieser Bezeichnung für dieses Projekt oder global." nicht angezeigt
      return observableThrowError(error);
    }
    else if (error.status === 422 || error.status === 401) {
      if (error.status === 422) {
        //console.log("CRUDBasicService.handleError error: ", error);
      }
      return observableThrowError(error.Concurrency || error.DbUpdateException || error.Error || 'Server Error');
    }
    else if(error.status >= 500 || error.status == 404 || error.status == 400 || (error.status == 0 || error.statusText == 'Unknown Error')){
      let errorDetails = {message: "Status Code: " + error.status + '<br>' + error.statusText + (error.error != null && typeof error.error == 'string' ? '\r\n' + '(' + error.error + ')' : '')};
      return observableThrowError(errorDetails);
    }

    return observableThrowError(error.error || 'Server error')
  }
}
